<form [formGroup]="formGroup" class="bg-white">
  <div class="development-title !pl-[36px] sticky top-0 !z-50">
    Pre-Qualification Questionnaire (PQQ)
    <span class="comapny-general-info">General Company Information</span>
  </div>

  <div class="container">
    <!-- General Company Information -->
    <div id="container_wrapper" class="container_wrapper">
      <div
        class="container-fluid flex h-auto p-[36px] !pt-0 !m-[3px] !mt-[0px] !mb-[0px] !pb-[0px]"
      >
        <div class="!p-[0px] !pb-0 !bg-[#ffffff] !pt-[0px]">
          <h3 class="company-detail !pb-0 pt-[25px]">Company Details</h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 gap-x-24 container"
          >
            <div class="container p-5 !pt-0 !pl-0 !pb-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field
                  class="!w-full !mb-[26px]"
                  appearance="outline"
                >
                  <mat-label> Full Legal Name of Company </mat-label>
                  <input
                    matInput
                    formControlName="company_name"
                    placeholder="Full Legal Name of Company"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup.get('company_name').hasError('required') &&
                    formGroup.get('company_name').touched
                  "
                >
                  Company name is required
                </mat-error>
              </div>
            </div>
            <div class="container  !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0 !mb-[26px] !max-w-[500px]">
                <mat-form-field
                  class="!w-full !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Registered Address </mat-label>
                  <input
                    matInput
                    formControlName="address"
                    placeholder="Registered Address"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup.get('address').hasError('required') &&
                    formGroup.get('address').touched
                  "
                >
                  Address is required
                </mat-error>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pb-0 !pt-0">
              <div class="rounded !pb-0 !pt-0 !mb-[26px] !max-w-[500px]">
                <mat-form-field
                  class="!w-full !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label>Company Registration Number</mat-label>
                  <input
                    matInput
                    formControlName="company_reg_no"
                    placeholder="Company Registration Number"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup.get('company_reg_no').hasError('required') &&
                    formGroup.get('company_reg_no').touched
                  "
                >
                  Company Registration Number is required
                </mat-error>
              </div>
            </div>

            <div class="container !pb-0 !pt-0">
              <div class="rounded !pb-0 !pt-0 !mb-[26px] !max-w-[500px]">
                <mat-form-field
                  class="!w-full !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label>VAT Registration Number</mat-label>
                  <input
                    matInput
                    formControlName="company_vat_no"
                    placeholder="VAT Registration Number"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup.get('company_vat_no').hasError('required') &&
                    formGroup.get('company_vat_no').touched
                  "
                >
                  VAT Registration Number is required
                </mat-error>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pb-0 !pt-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full" appearance="outline">
                  <mat-label>Email</mat-label>
                  <input
                    matInput
                    formControlName="email"
                    type="email"
                    placeholder="Email"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup.get('email').hasError('required') &&
                    formGroup.get('email').touched
                  "
                >
                  Email is required
                </mat-error>
              </div>
            </div>

            <div class="container  !pb-0 !pt-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full" appearance="outline">
                  <mat-label>Website</mat-label>
                  <input
                    formControlName="website"
                    matInput
                    placeholder="Website"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup.get('website').hasError('required') &&
                    formGroup.get('website').touched
                  "
                >
                  Website is required
                </mat-error>
              </div>
            </div>
            <div class="container p-5 !pl-0 !pb-0 !pt-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full" appearance="outline">
                  <mat-label>Telephone</mat-label>
                  <input
                    formControlName="phone"
                    matInput
                    type="text"
                    placeholder="Telephone"
                    [maxlength]="maxLength?.MOBILE_PHONE"
                    (keypress)="allowOnlyNumbers($event)"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup.get('phone').hasError('required') &&
                    formGroup.get('phone').touched
                  "
                >
                  Telephone number is required
                </mat-error>
                <mat-error
                  *ngIf="
                    formGroup.get('phone').hasError('pattern') &&
                    formGroup.get('phone').touched
                  "
                >
                  Invalid telephone number format
                </mat-error>
              </div>
            </div>
          </div>

          <h3 class="company-detail !pb-0">Contact Person</h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 gap-x-24 container"
          >
            <div class="container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full" appearance="outline">
                  <mat-label> Name </mat-label>
                  <input
                    matInput
                    formControlName="contact_person"
                    placeholder="Name"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup.get('contact_person').hasError('required') &&
                    formGroup.get('contact_person').touched
                  "
                >
                  Name is required
                </mat-error>
              </div>
            </div>
            <div class="container  !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full" appearance="outline">
                  <mat-label> Position </mat-label>
                  <input
                    matInput
                    formControlName="contact_person_position"
                    placeholder="Position"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup
                      .get('contact_person_position')
                      .hasError('required') &&
                    formGroup.get('contact_person_position').touched
                  "
                >
                  Position is required
                </mat-error>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full" appearance="outline">
                  <mat-label>Telephone</mat-label>
                  <input
                    formControlName="contact_person_phone"
                    matInput
                    type="text"
                    placeholder="Telephone"
                    [maxlength]="maxLength?.MOBILE_PHONE"
                    (keypress)="allowOnlyNumbers($event)"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup
                      .get('contact_person_phone')
                      .hasError('required') &&
                    formGroup.get('contact_person_phone').touched
                  "
                >
                  Telephone number is required
                </mat-error>
                <mat-error
                  *ngIf="
                    formGroup.get('contact_person_phone').hasError('pattern') &&
                    formGroup.get('contact_person_phone').touched
                  "
                >
                  Invalid telephone number format
                </mat-error>
              </div>
            </div>
            <div class="container  !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full" appearance="outline">
                  <mat-label> Email </mat-label>
                  <input
                    matInput
                    type="email"
                    formControlName="contact_person_email"
                    placeholder="Email"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup
                      .get('contact_person_email')
                      .hasError('required') &&
                    formGroup.get('contact_person_email').touched
                  "
                >
                  Email is required
                </mat-error>
              </div>
            </div>
          </div>

          <h3 class="company-detail !pb-0">Organization Structure</h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 gap-x-24 container "
          >
            <div class="container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]" >
                <mat-form-field class="!w-full" appearance="outline">
                  <mat-label>
                    Legal Status (e.g., Sole Trader, Partnership, Limited
                    Company)
                  </mat-label>
                  <input
                    matInput
                    formControlName="legal_status"
                    placeholder="Legal Status (e.g., Sole Trader, Partnership, Limited Company)"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup.get('legal_status').hasError('required') &&
                    formGroup.get('legal_status').touched
                  "
                >
                  Legal Status is required
                </mat-error>
              </div>
            </div>
            <div class="container  !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full" appearance="outline">
                  <mat-label>Year Established</mat-label>
                  <mat-select formControlName="year_established" >
                    <mat-option class="!bg-[#ffffff]" *ngFor="let year of yearsList" [value]="year">{{
                      year
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup.get('year_established').hasError('required') &&
                    formGroup.get('year_established').touched
                  "
                >
                  Year Established is required
                </mat-error>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px] ">
                <mat-form-field class="!w-full" appearance="outline">
                  <mat-label> Parent Company </mat-label>
                  <input
                    matInput
                    formControlName="parent_company"
                    placeholder="Parent Company"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup.get('parent_company').hasError('required') &&
                    formGroup.get('parent_company').touched
                  "
                >
                  Parent Company is required
                </mat-error>
              </div>
            </div>
            <div class="container !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full" appearance="outline">
                  <mat-label> Number of Direct Employees </mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="direct_employees"
                    placeholder="Number of Direct Employees"
                    min="0"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup.get('direct_employees').hasError('required') &&
                    formGroup.get('direct_employees').touched
                  "
                >
                  Number of Employees is required
                </mat-error>
              </div>
            </div>
            <div class="container p-5 !pl-0 !pt-0 !pb-0 ">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full" appearance="outline">
                  <mat-label>
                    Number of Subcontractors Regularly Used
                  </mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="subcontractor_count"
                    placeholder="Number of Subcontractors Regularly Used"
                    min="0"
                  />
                </mat-form-field>
                <mat-error
                  *ngIf="
                    formGroup.get('subcontractor_count').hasError('required') &&
                    formGroup.get('subcontractor_count').touched
                  "
                >
                  Number of Subcontractors is required
                </mat-error>
              </div>
            </div>
          </div>

          <h3 class="company-detail !pb-0">Company Size</h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 gap-x-24 container "
          >
            <div class="container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field
                  class="!w-full h-[46px]"
                  appearance="outline"
                >
                  <mat-label> Annual Turnover for the Past 3 Years </mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="annual_turnover"
                    currencyMask
                    [options]="{
                      prefix: currencySymbol,
                      thousands: ',',
                      decimal: '',
                      nullable: true,
                      allowZero: false,
                      precision: 0,
                      max: 100000000000,
                    }"
                  />
                  <mat-error
                    *ngIf="
                      formGroup.get('annual_turnover').hasError('required') &&
                      formGroup.get('annual_turnover').touched
                    "
                  >
                    Annual Turnover is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="justify-items-center !max-w-[500px]">
                <span class="w-full text-[12px]">
                  {{
                    numberToWords(formGroup.get("annual_turnover")?.value)
                      | titlecase
                  }}
                </span>
              </div>
            </div>
            <div class="container !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field
                  class="!w-full h-[46px]"
                  appearance="outline"
                >
                  <mat-label>
                    Number of Projects Completed (last 3 years)
                  </mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="completed_projects"
                  />
                  <mat-error
                    *ngIf="
                      formGroup
                        .get('completed_projects')
                        .hasError('required') &&
                      formGroup.get('completed_projects').touched
                    "
                  >
                    Number of Projects is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0">
                <mat-form-field
                  class="!w-[500px] h-[46px]"
                  appearance="outline"
                >
                  <mat-label> Total Number of Ongoing Projects </mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="ongoing_projects"
                    min="0"
                  />
                  <mat-error
                    *ngIf="
                      formGroup.get('ongoing_projects').hasError('required') &&
                      formGroup.get('ongoing_projects').touched
                    "
                  >
                    Number of Ongoing Projects is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
